module.exports = __webpack_public_path__ + "static/app-shot-n-1-1-4c82cb70088036075a0a79184424a05c.png";